import { PropertySetModule } from "@/services/admin/property-set/modal"
import { Button, Form, InputNumber, Select, Table } from "antd"
import { useEffect, useState } from "react"

export interface ReactionPartnersEditorProps {
  propertySet: PropertySetModule.Modal
  value?: PropertySetModule.ReactionPartner[]
  onChange?: (values: PropertySetModule.ReactionPartner[]) => void
}

export const ReactionPartnersEditor = (props: ReactionPartnersEditorProps) => {
  const {value, propertySet, onChange} = props
  const [form] = Form.useForm()
  const [partners, setPartners] = useState<PropertySetModule.ReactionPartner[]>(value || [])

  useEffect(() => {
    setPartners(value || [])
  }, [value])

  const options = propertySet.components?.map((item) => {
    return {
      value: item.id,
      label: `${item.name}(${item.formula})`
    }
  })

  const columns = [
    {
      title: 'Stoichiometric Coefficient',
      dataIndex: 'stoec',
      key: 'stoec',
    },
    {
      title: 'Component',
      dataIndex: 'id',
      render: (id) => {
        return propertySet.components.find(item => item.id === id)?.name || '-'
      }
    },
    {
      title: 'Actions',
      render: (_, record) => {
        return <Button size="small" danger onClick={() => {
          const newVal = partners.filter(item => item !== record)
          setPartners(newVal)
          onChange?.(newVal)
        }}>Delete</Button>
      }
    },
  ]

  return <div>
    <div className="mt-2">
      <Table
        bordered
        rowKey={'id'}
        pagination={{ pageSize: 20, hideOnSinglePage: true }}
        size='small'
        columns={columns}
        dataSource={partners}
      />
      <Form
        form={form}
        layout="inline"
        onFinish={(values) => {
          const newVal = [...partners, values]
          setPartners(newVal)
          onChange?.(newVal)
          form.resetFields()
        }}
        className="mt-2 border p-1"
      >
        <Form.Item label='Stoichiometric Coefficient' name='stoec' rules={[{ required: true, message: 'Please enter Stoichiometric Coefficient' }]}>
          <InputNumber type='text' style={{width: 60}} />
        </Form.Item>

        <Form.Item label='Component' name='id' rules={[{ required: true, message: 'Please selected a reaction type' }]}>
          <Select options={options} style={{width: 160}} />
        </Form.Item>

        <Button type="primary" onClick={() => form.submit()}>Add</Button>
      </Form>
    </div>
  </div>
}